import { NavLink, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/siteData';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isHome ? 'bg-transparent' : 'bg-background-50/95 backdrop-blur-sm'}`}>
      <nav className="w-full">
        <div className="mx-auto flex items-center justify-between px-4 md:px-6 py-4">
          <a href="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl font-heading font-bold text-primary-500">91.com</span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            <NavLink to="/" className={({ isActive }) => `text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${isActive ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'}`} end>
              首页
            </NavLink>
            {categories.map((cat) => (
              <NavLink key={cat.slug} to={`/category/${cat.slug}`} className={({ isActive }) => `text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${isActive ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'}`}>
                {cat.name}
              </NavLink>
            ))}
            <NavLink to="/about" className={({ isActive }) => `text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${isActive ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'}`}>
              关于我们
            </NavLink>
          </div>

          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700" aria-label="菜单">
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70">
            <div className="flex flex-col px-4 py-3 gap-2">
              <NavLink to="/" onClick={() => setMobileOpen(false)} className={({ isActive }) => `text-sm font-medium py-2 px-3 rounded-lg whitespace-nowrap cursor-pointer transition-colors ${isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'}`} end>
                首页
              </NavLink>
              {categories.map((cat) => (
                <NavLink key={cat.slug} to={`/category/${cat.slug}`} onClick={() => setMobileOpen(false)} className={({ isActive }) => `text-sm font-medium py-2 px-3 rounded-lg whitespace-nowrap cursor-pointer transition-colors ${isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'}`}>
                  {cat.name}
                </NavLink>
              ))}
              <NavLink to="/about" onClick={() => setMobileOpen(false)} className={({ isActive }) => `text-sm font-medium py-2 px-3 rounded-lg whitespace-nowrap cursor-pointer transition-colors ${isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'}`}>
                关于我们
              </NavLink>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}